import MultiSelectUI from "@UI/MultiSelectSuggestUI";
import TooltipUI from "@UI/TooltipUI";

import { useState, useRef } from "react";
import SelectButtonUI from "@UI/SelectButtonUI";
import { Calendar } from "primereact/calendar";

import moment from "moment";
import { inject, observer } from "mobx-react";
import { computed, toJS } from "mobx";
import { pluralForm } from "@utils";

import ButtonUI from "@UI/ButtonUI";

import "./style.scss";

const ActivationHeader = inject("mainStore")(
    observer(({ mainStore, titleName }) => {
        const traffic = mainStore.getMainStore("suggest.sites_suggest");
        const partners = mainStore.getMainStore("suggest.vendors_suggest");
        const offers = mainStore.getMainStore("suggest.offers_suggest");

        const trafficMod = mainStore.getMainStore("modified.sites_suggest");
        const partnersMod = mainStore.getMainStore("modified.vendors_suggest");
        const offersMod = mainStore.getMainStore("modified.offers_suggest");
        const ref = useRef(null);
        const [selected, setSelected] = useState({ siteIds: null, vendorIds: null, offerIds: null });
        const [dates, setDates] = useState(null);
        const [value, setValue] = useState(options[0].value);

        const getRangeByOption = (mode) => {
            const now = moment();
            switch (mode) {
                case "today":
                    return [now.clone().startOf("day").toDate(), now.clone().endOf("day").toDate()];
                case "week":
                    return [now.clone().subtract(6, "days").startOf("day").toDate(), now.clone().endOf("day").toDate()];
                case "month":
                    return [now.clone().subtract(29, "days").startOf("day").toDate(), now.clone().endOf("day").toDate()];
                default:
                    return [null, null];
            }
        };

        const handleSelect = (val) => {
            const mode = val;
            setValue(mode);
            const [start, end] = getRangeByOption(mode);
            setDates(null);

            mainStore.setMainStore("filter.startDate", moment(start).format("YYYY-MM-DD"));
            mainStore.setMainStore("filter.endDate", moment(end).format("YYYY-MM-DD"));
        };

        const handleDates = (e) => {
            const [start, end] = e.value;
            setDates([start, end]);

            if (start && end) {
                mainStore.setMainStore("filter.startDate", moment(start).format("YYYY-MM-DD"));
                mainStore.setMainStore("filter.endDate", moment(end).format("YYYY-MM-DD"));
            }
        };

        const handleBtn = () => {
            const hasRange = dates?.[0] && dates?.[1];
            setValue(null);
            if (hasRange) {
                setDates(null);
                handleSelect("today");
                return;
            }
            ref.current.show();
        };

        const handleChangeSelect = (val, key) => {
            setSelected({ ...selected, [key]: val });
            mainStore.setMainStore(`filter.filters.${key}`, val.length ? val : null);
        };

        const hasRange = !!(dates?.[0] && dates?.[1]);
        const buttonLabel = hasRange ? `${moment(dates[0]).format("DD.MM")} - ${moment(dates[1]).format("DD.MM")}` : "";

        const tooltipTraffic = selected.siteIds?.length
            ? selected.siteIds
                  .map((c) => trafficMod[c].name)
                  .filter(Boolean)
                  .join("\n")
            : false;

        const tooltipPartners = selected.vendorIds?.length
            ? selected.vendorIds
                  .map((c) => partnersMod[c].name)
                  .filter(Boolean)
                  .join("\n")
            : false;

        const tooltipOffer = selected.offerIds?.length
            ? selected.offerIds
                  .map((c) => offersMod[c].title)
                  .filter(Boolean)
                  .join("\n")
            : false;

        return (
            <div className="activation-header">
                <span className="activation-header__title">{titleName}</span>
                <TooltipUI target=".activation-header__vendor" content={tooltipPartners} position="bottom" />
                <TooltipUI target=".activation-header__site" content={tooltipTraffic} position="bottom" />
                <TooltipUI target=".activation-header__offer" content={tooltipOffer} position="bottom" />

                <MultiSelectUI
                    className="activation-header__vendor"
                    itemClassName="select__item"
                    emptyFilterMessage="Ничего не найдено"
                    emptyMessage="Ничего не найдено"
                    filter
                    value={selected.vendorIds}
                    onChange={(e) => handleChangeSelect(e.value, "vendorIds")}
                    options={partners || []}
                    optionLabel="name"
                    optionValue="_id"
                    display="chip"
                    placeholder="Вендор"
                    maxSelectedLabels={0}
                    selectedItemsLabel={selected.vendorIds?.length + " вендор" + pluralForm(selected.vendorIds?.length, ["", "а", "ов"])}
                    showClear
                    appendTo="self"
                />

                <MultiSelectUI
                    className="activation-header__site"
                    itemClassName="select__item"
                    emptyFilterMessage="Ничего не найдено"
                    emptyMessage="Ничего не найдено"
                    filter
                    value={selected.siteIds}
                    onChange={(e) => handleChangeSelect(e.value, "siteIds")}
                    options={traffic || []}
                    optionLabel="name"
                    optionValue="_id"
                    display="chip"
                    placeholder="Витрина"
                    maxSelectedLabels={0}
                    selectedItemsLabel={selected.siteIds?.length + " витрин" + pluralForm(selected.siteIds?.length, ["а", "ы", ""])}
                    showClear
                    appendTo="self"
                />

                <MultiSelectUI
                    className="activation-header__offer"
                    itemClassName="select__item"
                    emptyFilterMessage="Ничего не найдено"
                    emptyMessage="Ничего не найдено"
                    filter
                    value={selected.offerIds}
                    onChange={(e) => handleChangeSelect(e.value, "offerIds")}
                    options={offers || []}
                    optionLabel="title"
                    optionValue="_id"
                    display="chip"
                    placeholder="Офферы"
                    maxSelectedLabels={0}
                    selectedItemsLabel={selected?.offerIds?.length + " оффер" + pluralForm(selected?.offerIds?.length, ["", "а", "ов"])}
                    showClear
                    appendTo="self"
                />

                <div className="activation-header__container">
                    <SelectButtonUI value={value} onChange={(e) => handleSelect(e.value)} optionLabel="name" options={options} allowEmpty={false} />
                    <div className="activation-header__calendar">
                        <ButtonUI outlined={!!value} icon={hasRange ? "pi pi-times" : "pi pi-calendar"} onClick={handleBtn} label={buttonLabel} iconPos="right" />
                        <Calendar ref={ref} value={dates} onChange={handleDates} selectionMode="range" readOnlyInput hideOnRangeSelection locale="rus" />
                    </div>
                </div>
            </div>
        );
    }),
);

const options = [
    { name: "Сегодня", value: "today" },
    { name: "Неделя", value: "week" },
    { name: "Месяц", value: "month" },
];

export default ActivationHeader;
